import { LocalDate } from '../../core/model/local-date';
import { ModelBase } from '../../core/model/model-base';
import { Money } from '../../core/model/money';
import { CompanyMortgageAmortization } from './company-mortgage-amortization';

export class CompanyMortgage extends ModelBase {
  constructor(dataContext?: any) {
    super();
    if (!dataContext) {
      return;
    }
    this.amortizations = Array.isArray(dataContext.amortizations)
      ? dataContext.amortizations.map(a => new CompanyMortgageAmortization(a))
      : [];
    this.name = dataContext.name;
    this.initialAmount = new Money(dataContext.initialAmount.currencyCode, dataContext.initialAmount.amount);
    this.balance = new Money(dataContext.balance.currencyCode, dataContext.balance.amount);
    this.companyId = dataContext.companyId;
    this.creditInstituteId = dataContext.creditInstituteId;
    this.creditInstituteName = dataContext.creditInstituteName;
    this.companyName = dataContext.companyName;
    this.nextInterestRateChangeDate = dataContext.nextInterestRateChangeDate;
    this.currentInterestRate = dataContext.currentInterestRate;
  }

  amortizations: CompanyMortgageAmortization[] = [];
  name: string;
  initialAmount: Money;
  balance: Money;
  companyId: string;
  creditInstituteId: string;
  creditInstituteName: string;
  companyName: string;
  nextInterestRateChangeDate: LocalDate;
  currentInterestRate: number;

  toString(): string {
    return this.name;
  }
}
